// extracted by mini-css-extract-plugin
export var button = "_ts-1";
export var container = "_ts-0";